import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getClientSelfAssessmentList, getClientSelfAssessment, updateClientSelfAssessment } from "../slice/clientPanelSelfAssessmentSlice";

const ClientSelfAssessment = () => {
  const dispatch = useDispatch();
  const { clientsSelfAssessmentQuestions, clientsSelfAssessmentAnswer } = useSelector((state) => state.clientSelfAssessment);
  const clientToken = localStorage.getItem("client_access_token");

  const [formValues, setFormValues] = useState({});

    useEffect(() => {
      dispatch(getClientSelfAssessmentList(clientToken));
      dispatch(getClientSelfAssessment(clientToken));
    }, [dispatch]);

    // console.log("clientsSelfAssessmentQuestions", clientsSelfAssessmentQuestions);
    // console.log("clientsSelfAssessmentAnswer", clientsSelfAssessmentAnswer);

    useEffect(() => {
    if (clientsSelfAssessmentAnswer) {
      const prefilled = {};

      clientsSelfAssessmentAnswer.forEach((answer) => {
        if (answer.answer_text) {
          prefilled[answer.question_id] = answer.answer_text;
        } else if (answer.Ans?.length > 0) {
          const values = answer.Ans.map((a) => a.option);
          prefilled[answer.question_id] =
            values.length === 1 ? values[0] : values;
        }
      });

      setFormValues(prefilled);
    }
  }, [clientsSelfAssessmentAnswer]);

  const handleChange = (questionId, value, type) => {
    setFormValues((prev) => {
      if (type === "multiple_choice") {
        const prevValues = prev[questionId] || [];
        return {
          ...prev,
          [questionId]: prevValues.includes(value)
            ? prevValues.filter((v) => v !== value)
            : [...prevValues, value]
        };
      } else {
        return {
          ...prev,
          [questionId]: value
        };
      }
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const formattedPayload = clientsSelfAssessmentQuestions.map((q) => {
    const answer = formValues[q.id];

    if (q.question_type === "text") {
      return {
        a: answer || "",
        "'question_type'": q.question_type,
        "'id'": String(q.id),
      };
    }

    const ansArray = Array.isArray(answer) ? answer : [answer];

    return {
      "'question_type'": q.question_type,
      "'id'": String(q.id),
      ans: ansArray.filter(Boolean),
    };
  });

  // ✅ Wrap inside `options` and stringify
  const payload = {
    options: JSON.stringify(formattedPayload)
  };

  const result = await dispatch(updateClientSelfAssessment({ token: clientToken, options: payload }));

  if (result.meta.requestStatus === "fulfilled") {
    toast.success("Self Assessment Updated Successfully", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
    dispatch(getClientSelfAssessmentList(clientToken));
    dispatch(getClientSelfAssessment(clientToken));
  } else {
    toast.error("Failed to update self-assessment", {
      position: "top-right",
      autoClose: 2000,
      style: { fontSize: "0.85rem" },
    });
  }
};



  if (!clientsSelfAssessmentQuestions) return <p>Loading...</p>;


  return (
    // <form onSubmit={handleSubmit}>
    //   {clientsSelfAssessmentQuestions.map((q) => (
    //     <div key={q.id} className="mb-4">
    //       <label className="form-label"><strong>{q.question_title}</strong></label>
    //       <p className="text-muted">{q.description}</p>

    //       {/* Text Input */}
    //       {q.question_type === "text" && (
    //         <input
    //           type="text"
    //           className="form-control"
    //           value={formValues[q.id] || ""}
    //           onChange={(e) =>
    //             handleChange(q.id, e.target.value, q.question_type)
    //           }
    //         />
    //       )}

    //       {/* Single Choice Radio */}
    //       {q.question_type === "single_choice" &&
    //         q.Ans.map((opt) => (
    //           <div className="form-check" key={opt.id}>
    //             <input
    //               type="radio"
    //               className="form-check-input"
    //               name={`q-${q.id}`}
    //               value={opt.id}
    //               checked={formValues[q.id] == opt.id}
    //               onChange={() => handleChange(q.id, String(opt.id), q.question_type)}
    //             />
    //             <label className="form-check-label">{opt.option}</label>
    //           </div>
    //         ))}

    //       {/* Multiple Choice Checkbox */}
    //       {q.question_type === "multiple_choice" &&
    //         q.Ans.map((opt) => (
    //           <div className="form-check" key={opt.id}>
    //             <input
    //               type="checkbox"
    //               className="form-check-input"
    //               value={opt.id}
    //               checked={(formValues[q.id] || []).includes(String(opt.id))}
    //               onChange={() => handleChange(q.id, String(opt.id), q.question_type)}
    //             />
    //             <label className="form-check-label">{opt.option}</label>
    //           </div>
    //         ))}
    //     </div>
    //   ))}

    //   <button type="submit" className="btn btn-primary">Submit</button>
    // </form>
    <>
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat d-flex">
            Client Self Assessment
          </h4>
   <form onSubmit={handleSubmit}>
      {clientsSelfAssessmentQuestions.map((q) => (
        <div key={q.id} className="mb-4">
          <label className="form-label"><strong>{q.question_title}</strong></label>
          <p className="text-muted">{q.description}</p>

          {/* Text Input */}
          {q.question_type === "text" && (
            <input
              type="text"
              className="form-control"
              value={formValues[q.id] || ""}
              onChange={(e) =>
                handleChange(q.id, e.target.value, q.question_type)
              }
            />
          )}

          {/* Single Choice Radio */}
          {q.question_type === "single_choice" &&
            q.Ans.map((opt) => (
              <div className="form-check" key={opt.id}>
                <input
                  type="radio"
                  className="form-check-input"
                  name={`q-${q.id}`}
                  value={opt.id}
                  checked={formValues[q.id] == opt.id}
                  onChange={() => handleChange(q.id, String(opt.id), q.question_type)}
                />
                <label className="form-check-label">{opt.option}</label>
              </div>
            ))}

          {/* Multiple Choice Checkbox */}
          {q.question_type === "multiple_choice" &&
            q.Ans.map((opt) => (
              <div className="form-check" key={opt.id}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  value={opt.id}
                  checked={(formValues[q.id] || []).includes(String(opt.id))}
                  onChange={() => handleChange(q.id, String(opt.id), q.question_type)}
                />
                <label className="form-check-label">{opt.option}</label>
              </div>
            ))}
        </div>
      ))}

      <button type="submit" className="btn btn-custom-primary font-weight-medium font-size-16 text-capitalize px-4 rounded m-1">Submit</button>
    </form>
        </div>
      </div>
    </>
  );
};

export default ClientSelfAssessment;
